import Moment from 'moment'
import MomentTimeZone from 'moment-timezone'

window.moment = Moment
MomentTimeZone()

export default ({ $axios, redirect, store, $dialog, app }) => {
  const i18n = store.$i18n
  let isRefreshing = false
  const timezone = window.moment.tz.guess()
  $axios.setHeader('X-Time-Zone', timezone)
  $axios.setHeader('X-Console-Language', app.i18n.localeProperties.code)
  $axios.setHeader('X-Content-Type-Options', 'nosniff')
  $axios.setHeader('X-Frame-Options', 'DENY')
  app.i18n.onLanguageSwitched = (oldLocale, newLocale) => {
    $axios.setHeader('X-Console-Language', newLocale)
  }

  $axios.onResponse((response) => {
    // Logowanie odpowiedzi – tylko w trybie developerskim
    console.log(response)
    return response
  })

  $axios.onResponseError(async (error) => {
    const code = parseInt(error.response && error.response.status)

    if (!code) {
      $dialog.message.error('Oops, something went wrong.')
    }

    switch (code) {
      case 307:
        if (error.response.headers['bc-redirect']) {
          app.router.push('/login/')
        }
        return Promise.reject(error)
      case 401:
        if (!isRefreshing) {
          isRefreshing = true
          const originalRequest = { isError: false, response: undefined }
          await $axios
            .$post(
              '/auth/generate-token',
              {},
              {
                baseURL: app.$getApiUrls().secondApiUrl,
                withCredentials: true,
              }
            )
            .then(async (resp) => {
              await $axios
                .request(error.config)
                .then((resp) => {
                  isRefreshing = false
                  originalRequest.response = resp
                })
                .catch((err) => {
                  if (err.response.status !== 401) {
                    isRefreshing = false
                    originalRequest.isError = true
                    originalRequest.response = err
                  } else {
                    isRefreshing = false
                    app.$user.clearLocalStorage()
                    redirect('/login/')
                  }
                })
            })
            .catch(() => {
              isRefreshing = false
              app.$user.clearLocalStorage()
              redirect('/login/')
              // if (err.response.status === 307) {
              //   console.log(
              //     'err.response.headers[bc-redirect]:',
              //     err.response.headers['bc-redirect']
              //   )
              //   if (err.response.headers['bc-redirect']) {
              //     console.log('http status 307 - 4')
              //     redirect(err.response.headers['bc-redirect'])
              //   }
              // }
            })
          if (originalRequest.response) {
            return originalRequest.isError
              ? Promise.reject(originalRequest.response)
              : Promise.resolve(originalRequest.response)
          }
        }
        isRefreshing = false

        throw error
      case 403:
        $dialog.message.error(i18n.t('access_denied.accessNotPermittedMsg'))
        throw error
      case 404:
        $dialog.message.error(i18n.t('validation_new.destinationNotFound'))
        throw error
      case 500:
        $dialog.message.error(
          i18n.t('validation_new.somethingHappenedOnOurServers')
        )
        throw error
      default:
        throw error
    }
  })
}
